<template>
  <div>
    <label
      for="transition-duration"
      class="block text-sm leading-5 font-medium text-gray-700 mb-1 mt-4"
      >Pin options</label
    >
  <section class="bg-gray-100 mt-4 p-4 rounded-md">
    <span class="text-gray-700 text-sm font-medium leading-5 mr-4">
      Pin element?
    </span>

    <!-- CHECKBOX!! -->
    <input type="checkbox" v-model="element.pinElement" />
    <div v-if="element.pinElement" class="mt-4">
      <!-- PIN POSITION -->
      <label
        for="number-ticks"
        class="block text-sm leading-5 font-medium text-gray-700 mb-2"
        >Vertical pin position
        <span class="text-gray-500">(0 — top; 1 — bottom)</span></label
      >
      <v-select
        v-model="element.triggerHook"
        :options="hooks"
        class="bg-white text-gray-500"
      ></v-select>

      <!-- DURATION -->
      <label
        for="transition-duration"
        class="block text-sm leading-5 font-medium text-gray-700 mb-2 mt-4"
        >Pin duration <span class="text-gray-500">(pixels)</span></label
      >
      <v-select
        v-model="element.pinDuration"
        :options="transitionDuration"
        class="mb-4 bg-white"
      ></v-select>
    </div>
  </section>
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: ["element"],

  data() {
    return {
      hooks: [0, 0.1, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.7, 0.75, 0.8, 0.9, 1.0],
      transitionDuration: [200, 400, 600, 800, 1000, 1200, 1400, 1600],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
